import React from 'react'
import SignUpForm from '../Components/SignUpForm/SignUpForm'
import Navbar2 from '../Components/Navbar/Navbar2'


function SignUpPage() {
  return (
    <div>
        <Navbar2/>
        <SignUpForm/>
    </div>
  )
}

export default SignUpPage